/*
  <collapsible-tabs> — pestañas de especificaciones (General / Dimensiones / Detalles) que además
  se pueden expandir y contraer. Usado por sections/main-product-sc.liquid.

  - Click en una pestaña contraída o distinta de la abierta → se abre esa (icono −).
  - Click en la pestaña que ya está abierta → se contrae (icono +).
  Usa las mismas clases que component-tabs (.tabs__nav a, .tab, .active) para heredar sus estilos.
*/
if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('.tabs__nav a'));
        this.tabs = Array.from(this.querySelectorAll('.tab'));

        this.triggers.forEach((trigger) => {
          // currentTarget y no target: el click puede caer en el icono (span) de dentro del enlace.
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            this.toggle(event.currentTarget);
          });
          trigger.addEventListener('keydown', (event) => {
            if (event.key === ' ') {
              event.preventDefault();
              this.toggle(event.currentTarget);
            }
          });
        });
      }

      toggle(trigger) {
        const target = this.querySelector(trigger.getAttribute('href'));
        if (!target) return;

        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        this.triggers.forEach((el) => {
          const open = el === trigger && !isOpen;
          el.classList.toggle('active', open);
          el.setAttribute('aria-expanded', String(open));
        });

        this.tabs.forEach((tab) => {
          tab.classList.toggle('active', tab === target && !isOpen);
        });
      }
    }
  );
}
